import {Mapper} from '@s-ui/domain'

import {FiltersSearchValueObject} from '../../search/ValueObjects/FiltersSearchValueObject.js'

const YEARS_RANGE = {
  from: 2,
  to: 2
}

const CURRENT_YEAR = new Date().getFullYear()

const getYearTo = ({year}) =>
  // Prevent sending a year bigger than the current year
  year + YEARS_RANGE.to > CURRENT_YEAR ? CURRENT_YEAR : year + YEARS_RANGE.to

/**
 * @implements Mapper
 * Use an AdEntity to create a SearchRequestObject to get the related search to
 * an Ad so we can create an alert.
 */
export default class AdEntityToAdSearchParamsVOMapper extends Mapper {
  constructor({config, searchRequestValueObjectFactory}) {
    super()
    this._config = config
    this._searchRequestValueObjectFactory = searchRequestValueObjectFactory
    this._defaultPage = this._config.get('DEFAULT_PAGE_NUMBER')
    this._defaultSortBy = this._config.get('SORT_FIELDS').RELEVANCE
    this._defaultSortOrder = this._config.get('ORDER').DESC
  }

  setParams = ({params}) => {
    this._params = params

    return this
  }

  map = ({adEntity}) => {
    const filters = {
      bodyTypeIds: adEntity.getBodyTypeId() ? [adEntity.getBodyTypeId()] : [],
      categoryId: this._params.categoryId,
      category1Id: this._params.category1Id,
      category2Id: this._params.category2Id,
      fuelTypeIds: adEntity.getFuelTypeId() ? [adEntity.getFuelTypeId()] : [],
      offerTypeId: this._params.offerTypeId,
      provinceIds: adEntity.getProvinceId() ? [adEntity.getProvinceId()] : [],
      transmissionTypeId: adEntity.getTransmissionTypeId(),
      vehicles: [
        {
          makeId: adEntity.getMakeId(),
          modelId: adEntity.getModelId()
        }
      ],
      year: {
        from: adEntity.getYear() - YEARS_RANGE.from,
        to: getYearTo({year: adEntity.getYear()})
      }
    }
    return FiltersSearchValueObject.createFromApi({
      config: this._config,
      filters,
      listingSectionId: this._params.listingSectionId
    })
  }
}
